import { Component, Input } from '@angular/core';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';

import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';

@Component({
  selector: 'app-cms-link',
  templateUrl: './cms-link.component.html',
})
export class CmsLinkComponent {
  @Input() public isExternalLink: boolean;
  @Input() public isMobile: boolean;
  @Input() public text: string;
  @Input() public url: string;
  @Input() public variant = VtmnPlayButtonVariantEnum.PRIMARY;
  @Input() public shape = VtmnPlayButtonShapeEnum.SQUARED;

  public readonly VtmnPlayButtonSize = VtmnPlayButtonSizeEnum;
}
